import * as Sentry from '@sentry/react';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import API from '../API';
import { getStats } from '../dataProviders';

export const useLogin = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const [username, setUsername] = useState(window.localStorage.getItem('username'));
	const [password, setPassword] = useState('');
	const [inputType, setInputType] = useState('password');
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');

	useEffect(() => {
		if (location.pathname !== '/logout') return;

		API.logout();
	}, [location.pathname]);

	const message = location.pathname === '/logout' ? 'Wylogowano' : '';

	const passwordChange = () => {
		setLoading(false);

		navigate('/passchange', {
			state: password,
		});
	};

	const enter = async () => {
		const stats = await getStats(location);
		// await import('../pages/panel');

		setLoading(false);

		navigate('/panel', {
			state: { stats },
		});
	};

	const validate = () => {
		setError('');

		if (!username) {
			setError('Podaj login');
			return false;
		}

		if (!password) {
			setError('Podaj hasło');
			return false;
		}

		return true;
	};

	const handleLogin = async (e) => {
		e.preventDefault();

		if (!validate()) return;

		try {
			setLoading(true);

			const result = await API.login(username, password);
			sessionStorage.setItem('level', result.level);
			sessionStorage.setItem('id', result.id);
			localStorage.setItem('username', username!);

			Sentry.setUser({
				id: result.id,
				username: username!,
			});

			if (result.passwordChange === true) return passwordChange();
			else return await enter();
		} catch (e) {
			setLoading(false);

			console.trace(e);
			setError(`${e}`);
		}
	};

	return {
		username,
		password,
		inputType,
		loading,
		message: error || message,
		error,
		usernameChanged: (e) => setUsername(e.target.value),
		passwordChanged: (e) => setPassword(e.target.value),
		touchStart: (e) => {
			e.stopPropagation();

			setInputType('text');
		},
		touchMove: (e) => {
			e.stopPropagation();

			setInputType('password');
		},
		touchEnd: (e) => {
			e.preventDefault();
			e.stopPropagation();

			setInputType('password');
		},
		login: handleLogin,
	};
};
